import React from 'react';
import Style from './content.tailwind.js';

export function ContentLeft({ children }){

  return (
    <div className={ Style.contentLeft }>
      { children }
    </div>
  );
}